import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const ResultFiltersContainer = styled(Box)({
  margin: "0 1%",
  padding: "1%",
  marginTop: "14px",
  backgroundColor: "white",
  borderRadius: "5px",
  border: "0.91px solid #E5E5E5",
});
